import { useState } from "react";

import LoadingSpinner from "../../images/icon_loading_green.gif";
import { HTTP_METHODS } from "../../utils/constants";
import { networkBackendRequest } from "../../utils/networkUtils";
import Modal from "../Modal/Modal";
import {
  Button,
  ButtonContainer,
  CharacterEnable,
  Container,
  TextArea,
  TextContainer,
} from "./PaymentCommentModalStyles";

function PaymentCommentModal(props) {
  const {
    toggleModal,
    index,
    quotationId,
    quotationComment,
    refreshPage,
    limitQuotationComment,
  } = props;
  const [comment, updateComment] = useState(
    quotationComment ? quotationComment : ""
  );
  const [waitingForServerResponse, updateWaitingForServerResponse] =
    useState(false);

  const onCommentChange = (ev) => {
    updateComment(ev.target.value);
  };

  const onClose = () => {
    if (toggleModal != null) {
      toggleModal();
    }
  };

  function makeRequest() {
    return networkBackendRequest(
      `/quotations/${quotationId}/`,
      HTTP_METHODS.PATCH,
      {},
      {
        quotation_comment: comment,
      }
    ).then(() => toggleModal());
  }

  return (
    <Modal
      onOutsideClick={() => {
        onClose();
      }}
    >
      <Container>
        <h1>Ingresar comentario a prefactura del volante {index}</h1>
        <TextContainer>
          <h3>Ingresar comentario</h3>
          <TextArea
            type="text"
            placeholder={"Ingresar algún comentario..."}
            onChange={onCommentChange}
            value={comment}
            maxLength={limitQuotationComment}
          />
        </TextContainer>
        <CharacterEnable>
          <div>Caracteres disponibles:</div>
          <div style={{ width: "2.5rem" }}>
            {limitQuotationComment - comment.length}
          </div>
        </CharacterEnable>
        <ButtonContainer
          onClick={() => {
            if (waitingForServerResponse) return true;
            updateWaitingForServerResponse(true);
            makeRequest()
              .then(() => {
                updateWaitingForServerResponse(false);
                refreshPage();
              })
              .catch(() => updateWaitingForServerResponse(false));
          }}
        >
          <Button>
            {waitingForServerResponse && (
              <img className="icon" src={LoadingSpinner} alt="spinner" />
            )}
            Agregar Comentario
          </Button>
        </ButtonContainer>
      </Container>
    </Modal>
  );
}

export default PaymentCommentModal;
